import { render, staticRenderFns } from "./package-composer.vue?vue&type=template&id=245d543e"
import script from "./package-composer.vue?vue&type=script&lang=js"
export * from "./package-composer.vue?vue&type=script&lang=js"
import style0 from "./package-composer.vue?vue&type=style&index=0&id=245d543e&prod&lang=scss"
import style1 from "./package-composer.vue?vue&type=style&index=1&id=245d543e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports